<template>
  <div>
    <el-tag
      :key="`${index}-${tag}`"
      v-for="(tag, index) in importTags"
      closable
      type="warning"
      :disable-transitions="false"
      @close="HandleClose(tag)">
      {{ tag }}
    </el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="HandleInputConfirm"
      @blur="HandleInputConfirm">
    </el-input>
    <el-button v-else class="button-new-tag" size="small" @click="HandleShowInput">+ 添加 IP</el-button>
  </div>
</template>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 120px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<script>
export default {
  props: ['importTags'],
  data() {
    return {
      inputVisible: false,
      inputValue: '',
    }
  },
  methods: {
    HandleClose(tag) {
      this.importTags.splice(this.importTags.indexOf(tag), 1)
      this.HandleDataUpdate()
    },
    HandleShowInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    HandleInputConfirm() {
      if ( this.importTags.indexOf( this.inputValue ) !== -1 ) {
        this.$notify.error('资料重复，请再次确认')
      } else {
        let inputValue = this.inputValue
        if (inputValue) {
          this.importTags.push(inputValue)
        }
        this.HandleDataUpdate()
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    HandleDataUpdate() {
      this.$emit('HandleTagger', this.importTags)
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Tagger/index.vue